import { Injectable } from '@angular/core';

import {default as AggoOrderColumnsJSON} from 'app/Shared/Constant/Grid Column Names/AGGO-Columns.json';
import {default as TDETColumnsJSON} from 'app/Shared/Constant/Grid Column Names/TDET-Columns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UserService } from 'app/Shared/Services/user.service';
import { Observable } from 'rxjs';
@Injectable()
export class EventConversionService {
    aggoOrdersCols: any;
    columnJson: any = [];
    handlingInstructionCols: any;
    tdetCols: any;

    constructor(private gridService: GridService ,
        private urlsService: UrlsService,
        private userService: UserService,
        private sharedHttpClientService: SharedHttpClientService) {
        this.aggoOrdersCols = AggoOrderColumnsJSON;
        this.tdetCols = TDETColumnsJSON;
        this.handlingInstructionCols = this.userService.handlingInstructionsJSON;

    }
    getFiledDictionaryForEditView(payload:any, pageName:any): Observable<any> {
      let url = pageName === 'finraException' ? APIURL.FINRA_ConvertEvent : APIURL.CAT_ConvertEvent
        return this.sharedHttpClientService.post(
            this.urlsService.setAPIURl(url) , payload
          );
    }

    saveConvertedEvent(payload:any, pageName:any) {
      let url = pageName === 'finraException' ? APIURL.FINRA_ConvertEventSave : APIURL.CAT_ConvertEventSave
        return this.sharedHttpClientService.post(
            this.urlsService.setAPIURl(url) , payload
          );
    }
    getAggoOrdersColumns() {
        let column: any = this.aggoOrdersCols;
        this.columnJson = [];
        if (column != null || column != undefined) {
            this.aggoOrdersCols = this.gridService.getGridColumns(column);
        }
    }

    getTDETColumns() {
        let column: any = this.tdetCols;
        this.columnJson = [];
        if (column != null || column != undefined) {
          this.tdetCols = this.gridService.getGridColumns(column);
        }
      }

      getFDID(givenNameForFDID:any) {
        return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(
            APIURL.CAT_Exception_Get_FDID
            ), {
              "mpid": this.userService.getActiveMPID(),
              "givenName": givenNameForFDID
          })      
      }

}